import { Component } from 'react'
import PropTypes from 'prop-types'
import LoadingDots from './ui/shared/loading-dots'

export default class Table extends Component {
  render() {
    const presentColumns = this.props.columns.filter(col => !!col)
    const { data, empty, loading } = this.props
    return (
      <>
        {(!loading &&
          (!empty || (data && data.length > 0) ? (
            <table className="table table-striped table-hover tw-relative tw-max-w-full">
              <thead className="tw-bg-white tw-top-0 tw-left-0 tw-sticky tw-top-0 tw-z-10">
                <tr>
                  {presentColumns.map((col, i) => (
                    <th
                      key={col.id || col.name || `column-index-${i}`}
                      className={
                        (col.id ? 'sortable ' : '') +
                        (this.props.sort && this.props.sort.id === col.id
                          ? ` sort ${this.props.sort.dir}`
                          : '') +
                        (col.headerClassName ? ' ' + col.headerClassName : '')
                      }
                      onClick={
                        col.id && !(col.sort !== undefined && !col.sort)
                          ? () =>
                              this.props.onSortChange({
                                col,
                                dir:
                                  this.props.sort &&
                                  this.props.sort.id === col.id
                                    ? this.props.sort.dir === 'asc'
                                      ? 'desc'
                                      : 'asc'
                                    : 'desc',
                              })
                          : undefined
                      }>
                      {col.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!loading &&
                  data.map((d, dataIndex) => (
                    <tr
                      key={
                        (this.props.rowKeyFn && this.props.rowKeyFn(d)) || d.id
                      }
                      className={
                        typeof this.props.rowClassName === 'function'
                          ? this.props.rowClassName(d)
                          : this.props.rowClassName
                      }
                      onClick={e => {
                        if (
                          this.props.onEntityClicked &&
                          // Prevent firing the click action if the user
                          // really selected a text
                          window.getSelection().toString().length === 0
                        ) {
                          e.preventDefault()
                          this.props.onEntityClicked(d)
                        }
                      }}>
                      {presentColumns.map((col, i) => (
                        <td
                          className={col.classFn && col.classFn(d)}
                          key={col.id || col.name || `column-index-${i}`}>
                          {col.fn(d, dataIndex)}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            empty
          ))) ||
          (loading && (
            <div className="tw-h-full tw-flex tw-flex-col tw-justify-center tw-pt-8 tw-pb-32">
              <LoadingDots primaryColor />
            </div>
          ))}
      </>
    )
  }
}

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  empty: PropTypes.node,
  loading: PropTypes.bool,
  sort: PropTypes.object,
  onSortChange: PropTypes.func,
  rowKeyFn: PropTypes.func,
  rowClassName: PropTypes.string,
  onEntityClicked: PropTypes.func,
}
